import { useMemo, useCallback } from "react";
import { AuthContext } from "@/contexts/Auth";
import { api } from "@/services/api";
import { ReactElement, useEffect, useState } from "react";
import { redirect } from "react-router-dom";
import { useCookies } from "react-cookie";
interface AuthProviderProps {
  children?: ReactElement;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const storedToken = localStorage.getItem("@App:token");
  const storedUser = localStorage.getItem("@App:user");
  const storedBaseUrl = localStorage.getItem("@App:baseurl") || undefined;
  const storedAutoridade = localStorage.getItem("@App:autoridade") || "[]";

  const [cookieHash, setCookie] = useCookies(["hascorp", "token"]);

  const [baseUrl, setBaseUrl] = useState<string | undefined>(storedBaseUrl);
  const [signed, setSigned] = useState<boolean>(!!storedUser);
  const [autoriade, setAutoridade] = useState<string[]>(
    JSON?.parse(storedAutoridade)
  );
  const [user, setUser] = useState<string | null>(storedUser ? storedUser : "");

  const [token, setToken] = useState<string>(storedToken || "");

  useEffect(() => {
    api.interceptors.request.use(function (config) {
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    });

    api.interceptors.response.use(function (response) {
    
      return response;
    }, function (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        localStorage.removeItem("@App:user");
        localStorage.removeItem("@App:token");
        localStorage.clear();
        window.location.replace('/logout');
      }
      return Promise.reject(error);
    });

    if (signed && baseUrl) {
      api.interceptors.request.use(function (config) {
        config.headers["Authorization"] = token
          ? `Bearer ${token}`
          : config.headers["Authorization"];
        config.baseURL = baseUrl + "/api";
        return config;
      });
    }
    setCookie("token", token);
    setCookie("hascorp", generationHash());
  }, [token, baseUrl]);


  const signIn = useCallback(
    (user: string, token: string, autoridade: string[]) => {
      setUser(user);
      setToken(token);
      setAutoridade(autoridade);
      setSigned(true);

      localStorage.setItem("@App:autoridade", JSON.stringify(autoridade));
      localStorage.setItem("@App:user", user);
      localStorage.setItem("@App:token", token);
    },
    []
  );

  const generationHash = () => {
    const nav = window.navigator;
    const screenInfo = window.screen;

    const fingerprintData = [
      nav.userAgent,
      nav.platform,
      nav.language,
      nav.languages.join(","),
      screenInfo.width,
      screenInfo.height,
      screenInfo.colorDepth,
      screenInfo.pixelDepth,
      new Date().getTimezoneOffset(),
      nav.javaEnabled(),
    ];

    const fingerprintString = fingerprintData.join("||");
    let hash = 0;
    for (let i = 0; i < fingerprintString.length; i++) {
      const char = fingerprintString.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(36);
  };

  const signOut = useCallback(() => {
    setUser(null);
    setToken("");
    setSigned(false);
    localStorage.removeItem("@App:baseurl");
    localStorage.removeItem("@App:user");
    localStorage.removeItem("@App:token");
  }, []);

  const context = useMemo(
    () => ({
      signed,
      user,
      token,
      signIn,
      signOut,
      setBaseUrl,
      baseUrl,
      autoridade: autoriade,
    }),
    [
      signed,
      user,
      token,
      signIn,
      signOut,
      setBaseUrl,
      baseUrl,
      setToken,
      autoriade,
    ]
  );

  return (
    <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
  );
}